<template
  ><div style="padding-top:-2px;margin-top:-2px;">
    <v-label
      ><b>{{ label }}</b></v-label
    >
    <s-select-generic
      autocomplete
      class="text"
      itemvalue="GenID"
      :disabled="disabled"
      :value="value"
      id="GenDescription" itemtext="GenDescription"
      :return-object="false"
      @input="input($event)"
      :config="config"
      :full="full"
      :text="text"
      :clearable="clearable"
      no-default
    >
    </s-select-generic>

    
  </div>
</template>



<script>
import _sGenericService from "./../../services/General/GenericService";

export default {
  props: {
    projectID: {
      type: Number,
      default: 0,
    },
    value: null,
    text: { type: String, default: "" },
    label: {
      type: String,
      default: "",
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    projectID: {
      immediate: true, // Ejecutar cuando el componente se monta
      handler(newID) {
        this.updateConfig(newID);
      },
    },
  },
  data() {
    return {
      config: {},
    };
  },
  methods: {
    updateConfig(TkpID) {
      this.config = {
        url: _sGenericService.getUrlAssignedProject(),
        title: this.label,
        params: {
          search: "",
          requestID: this.$fun.getUserID(),
          TkpID: TkpID, // Actualizamos el ID del proyecto
        },
      };
    },
    input(val) {
      this.$emit("input", val);
    },
  },
};
</script>

